import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { mawbEndpoint, shipmentEndpoint } from 'src/app/utils/constants/requestUrl';

@Injectable({
  providedIn: 'root',
})
export class MappingService {
  constructor(private http: HttpClient) {}

  uploadShipments(data) {
    return this.http.post(`${environment.shipmentUrl}${shipmentEndpoint.uploadFile}`, data);
  }

  uploadLineItem(data) {
    return this.http.post(`${environment.mawbUrl}${mawbEndpoint.invoiceUpload}`, data);
  }

  uploadInvoice(data) {
    return this.http.post(`${environment.mawbUrl}${mawbEndpoint.uploadCI}`, data);
  }

  uploadBabyInvoice(data) {
    return this.http.post(`${environment.shipmentUrl}${shipmentEndpoint.uploadCI}`, data);
  }
}
